import {computed, observable} from 'mobx';

class Menu {
  id = null;

  name;

  parentId;

  url;

  code;

  order;

  nameEn;

  nameZh;

  nameJson;

  @observable children = [];

  @observable isAssigned;

  @observable sourceApp = {};

  @computed get key() {
    return this.id;
  }

  @computed get title() {
    return this.name;
  }

  constructor(store, data) {
    this.store = store;
    this.id = data.id;
    this.name = data.name;
    this.url = data.url;
    this.code = data.code;
    this.isAssigned = data.isAssigned;
    this.parentId = data.parentId;
    // for shortcut app
    this.nameEn = data.nameEn;
    this.nameZh = data.nameZh;
    if (data.sourceApp) {
      this.sourceApp.id = data.sourceApp.id;
      this.sourceApp.name = data.sourceApp.name;
      this.sourceApp.nameEn = data.sourceApp.nameEn;
      this.sourceApp.nameZh = data.sourceApp.nameZh;
    }
    this.nameJson = data.nameJson;
  }

  updateFromJson(json) {
    this.name = json.name;
    this.nameEn = json.nameEn;
    this.nameZh = json.nameZh;
    this.isAssigned = json.isAssigned;
    this.nameJson = json.nameJson;
    this.url = json.url;
  }

  updateChildren(json) {
    this.children = json;
  }
}

export default Menu;
